'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddButton = function AddButton(_ref) {
  var caption = _ref.caption,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'button',
    { type: 'button', className: 'btn btn-sm btn-secondary', onClick: onClick },
    caption
  );
};

AddButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  caption: _propTypes2.default.string.isRequired
};

exports.default = AddButton;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/AddButton.js
// module id = 205
// module chunks = 0